import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=6ba3312c&"
import script from "./contact.vue?vue&type=script&lang=ts&"
export * from "./contact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Toast: require('/home/vsts/work/1/s/frontend/components/notification/toast.vue').default,SystemDialog: require('/home/vsts/work/1/s/frontend/components/system-dialog.vue').default,SessionManagementNotification: require('/home/vsts/work/1/s/frontend/components/session-management-notification.vue').default})


/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
